import { render, staticRenderFns } from "./homepastwIn.vue?vue&type=template&id=5acb5d90&scoped=true&"
import script from "./homepastwIn.vue?vue&type=script&lang=js&"
export * from "./homepastwIn.vue?vue&type=script&lang=js&"
import style0 from "./homepastwIn.vue?vue&type=style&index=0&id=5acb5d90&prod&lang=less&"
import style1 from "./homepastwIn.vue?vue&type=style&index=1&id=5acb5d90&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb5d90",
  null
  
)

export default component.exports